<script lang="ts">
  import { Icon, Tooltip } from '$shared/components';
  import { getDateDiff } from '$shared/helpers/date';
  import Label from '$shared/constants/Label';
  import { EmptyLabelDefault } from '$shared/constants/global';
  import type { OverviewTableRow } from '$shared/models/OverviewTableRow';

  interface Props {
    row: OverviewTableRow;
    column: ColumnType;
  }

  let { row, column }: Props = $props();

  let value = $derived(row?.expirationDate);
  let tipLabel = $derived((() => {
    if (value) {
      const dateDiff: number = getDateDiff(value);
      if (!isNaN(dateDiff) && dateDiff < 0) {
        return Label.Expired;
      }
    }
    return '';
  })());
</script>

<div class="comp-expiredate-cell">
  {#if value}
    <div class="value">{value}</div>
    {#if tipLabel}
      <Tooltip label={tipLabel} top>
        <div class="icon"><Icon value="icon-alert-triangle" /></div>
      </Tooltip>
    {/if}
  {:else}
    {EmptyLabelDefault}
  {/if}
</div>

<style>
  .comp-expiredate-cell {
    position: relative;
    display: flex;
    line-height: 15px;
  }
  .value {
    margin-right: 6px;
  }
</style>
